import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

function authHeaders(token) {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
}

export async function getSalonValuationConfig(token, salonId = null) {
  const res = await axios.get(`${API}/reports/salon-valuation/config`, {
    params: salonId ? { salon_id: salonId } : undefined,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateSalonValuationConfig(payload, token, salonId = null) {
  const res = await axios.put(`${API}/reports/salon-valuation/config`, payload, {
    params: salonId ? { salon_id: salonId } : undefined,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function runSalonValuationReport(payload, token) {
  const res = await axios.post(`${API}/reports/salon-valuation/run`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}
